import API_BASE_URL from "../../config";

import axios from 'axios'

//import { Link } from "react-router-dom";

class AuthenticationService {
    // 서버에 사용자이름, 비밀번호 보내기
    executeJwtAuthenticationService(username, password, branch) {
        // return axios.post(`${API_BASE_URL}/api/authenticate`, {
        return axios.post(`${API_BASE_URL}/api/login`, {
            username,
            password,
            branch, 
        });
    }

    // 토큰 재발행 및 반환
    executeRefreshToken() {
        return axios.post(`${API_BASE_URL}/api/refresh-jwt`);
    }

    executeHelloService() {
        // console.log("===executeHelloService===");
        return axios.get(`${API_BASE_URL}/hello`);
    }

    registerSuccessfulLoginForJwt(username, accessToken, branch) {
        localStorage.setItem("token", accessToken);
        localStorage.setItem("authenticatedUser", username);
        localStorage.setItem("authenticatedBranch", branch);
    }

    createJWTToken(token) {
        return "Bearer " + token;
    }

    setupAxiosInterceptors() {
        /**
         * request interceptor
         * 2개의 콜백함수를 받음
         */
        axios.interceptors.request.use(
            (config) => {
                // 요청을 보내기 전에 수행
                const token = localStorage.getItem("token");
                if (token) {
                    config.headers["Authorization"] = this.createJWTToken(token);
                }
                config.headers['Content-Type'] = "application/json; charset=utf-8";
                return config;
            },
            (error) => {
                // 오류 요청을 보내기전 수행
                Promise.reject(error);
            }
        );

        /**
         * response interceptor
         * 2개의 콜백 함수를 받음.
         */
        axios.interceptors.response.use(
            (response) => {
                /**
                 * http status가 200인 경우 응답 성공 직전 호출됩니다. (응답 데이터 가공)
                 * .then() 으로 이어집니다.
                 */

                return response;
            },
            async (error) => {
                let errResponseStatus = null;
                const originalRequest = error.config;

                try {
                    errResponseStatus = error.response.status;
                } catch (e) {
                    console.log(e);
                }
                /**
                 * http status가 200이 아닌 경우 응답 에러 직전 호출됩니다. (오류 응답을 처리)
                 * .catch() 으로 이어집니다.
                 */

                // access token이 만료되어 발생하는 에러인 경우
                // console.log(originalRequest.retry);
                if ((error.message === "Network Error" || errResponseStatus === 401) && !originalRequest.retry) {
                    originalRequest.retry = true;

                    // refresh token을 이용하여 access token 재발행 받기
                    localStorage.removeItem("token");
                    return this.executeRefreshToken()
                        .then((res) => {
                            const resultMessage = res.data.result;
                            const accessToken = res.data.accessToken;
                            if (resultMessage === "success") {
                                localStorage.setItem("token", accessToken);

                                originalRequest.headers["Authorization"] = this.createJWTToken(accessToken);
                                
                                return axios(originalRequest);

                            } else if (resultMessage === "fail") {
                                this.logout();
                                window.location.href = "/login";
                                if (localStorage.getItem("i18nextLng") == "en") {
                                    alert("User authentication failed.\nPlease Logout.");
                                } else {
                                    alert("사용자 인증에 실패하였습니다.\n로그아웃 바랍니다.");
                                }
                                return Promise.reject(error);
                            }
                        })
                        .catch((error) => {
                            this.logout();
                            window.location.href = "/login";
                            if (localStorage.getItem("i18nextLng") == "en") {
                                alert("User authentication has expired.\nPlease Login again.");
                            } else {
                                alert("사용자 인증이 만료 되었습니다.\n다시 로그인 해주세요.\n" + error);
                            }
                            return Promise.reject(error);
                        });
                }
                return Promise.reject(error);
            }
        );
    }

    logout() {
        localStorage.clear();
        return axios.post(`${API_BASE_URL}/api/logout`);
    }

    // 로그인 체크 (true, false)
    isUserLoggedIn() {
        const token = localStorage.getItem("token");
        if (token) return true;
        return false;
    }

    // 로그인 유저ID
    getLoggedInUserID() {
        let user = localStorage.getItem("authenticatedUser");
        if (user === null) return "";
        return user;
    }
    getLoggedInUserBranchCd() {
        let user = localStorage.getItem("authenticatedBranch");
        if (user === null) return "";
        return user;
    }
    getLoggedInToken() {
        let user = localStorage.getItem("token");
        if (user === null) return "";
        return user;
    }

    // 로그인 유저 Name
    getLoggedInUserName() {
        const userName = localStorage.getItem('userName');
        if (userName === null) return localStorage.getItem("authenticatedUser");
        return userName;
    }

    getLoggedInUserGroup() {
        const userName = localStorage.getItem('group');
        if (userName === null) return localStorage.getItem("authenticatedUser");
        return userName;
    }

    getLoggedInUserStore() {
        const userName = localStorage.getItem('store');
        if (userName === null) return localStorage.getItem("authenticatedUser");
        return userName;
    }

    getLoggedInUserBranch() {
        const userName = localStorage.getItem('branch');
        if (userName === null) return localStorage.getItem("authenticatedUser");
        return userName;
    }
}

export default new AuthenticationService()